import axiosInstance from "../libs/axiosInstance";



// Get admin analytics
export const getAdminAnalytics = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/analytics/admin/analytics/', { params });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching admin analytics:', error);
    throw error;
  }
};

// Get only total_bank_questions from admin analytics (lightweight poll)
export const getTotalBankQuestions = async () => {
  try {
    const response = await axiosInstance.get('/analytics/admin/analytics/', {
      params: { fields: 'total_bank_questions' }
    });
    
    return response.data?.total_bank_questions || 0;
  } catch (error) {
    console.error('Error fetching total bank questions:', error);
    throw error;
  }
};

export const getLecturerAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/lecturer/analytics/');
    
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getLecturerCourseAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/lecturer/course-analytics/');
    
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getLecturerWeeklyReportAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/lecturer/weekly-performance/');
    
    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getStudentAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/student/');

    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getStudentQuizPerformanceAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/student/quiz-performance/');

    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getStudentQuizStatsAnalytics = async () => {
  try {
    const response = await axiosInstance.get('/analytics/student/quiz-stats/');

    return response.data;
  } catch (error) {
    console.error('Error creating course:', error);
    throw error;
  }
};

export const getStudentPerformanceByCourse = async () => {
  try {
    const response = await axiosInstance.get('/analytics/student/performance-by-course/');
    return response.data;
  } catch (error) {
    console.error('Error fetching student performance by course:', error);
    throw error;
  }
};

export const getStudentPerformanceByTopic = async () => {
  try {
    const response = await axiosInstance.get('/analytics/student/performance-by-topic/');
    return response.data;
  } catch (error) {
    console.error('Error fetching student performance by topic:', error);
    throw error;
  }
};
